import React, { useEffect, useState } from 'react';
import { Localizer } from 'services/Localizer';
import { getUserData } from 'services/UserData';
import Spinner from 'shared/components/Spinner';
import InlineAlert from 'shared/edit/InlineAlert';
import { TextAreaField, TextBoxField } from 'shared/edit/fields';
import ReCaptchaDisclaimer from 'shared/edit/fields/ReCaptchaDisclaimer';
import { useAxiosFormSubmitter } from 'shared/hooks/useBaseAxiosFormSubmitter';
import RocForm from 'shared/edit/RocForm';
import { ServerData } from 'services/ServerData';

interface ContactFormValues {
	name: string;
	email: string;
	message: string;
	// #region HCL
	customerNumber: string;
	// #endregion
}

/**
 * Contact Form component
 */
function ContactForm() {
	const [initialValues, setInitialValues] = useState<ContactFormValues>({
		name: '',
		email: '',
		message: '',
		// #region HCL
		customerNumber: '',
		// #endregion
	});

	const contactFormSubmitter = useAxiosFormSubmitter<ContactFormValues>(
		{
			url: '/ajax/contact',
		},
		'ContactForm',
	);

	// initialize the contact us fields with values from the user record.
	useEffect(() => {
		(async () => {
			const userDataResponse = await getUserData();

			if (!userDataResponse.data || !userDataResponse.data.summary) {
				return;
			}

			const { firstName, lastName, email } = userDataResponse.data.summary;

			setInitialValues({
				...initialValues,
				name: firstName && lastName ? `${firstName} ${lastName}` : '',
				email: email || '',
			});
		})();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return !contactFormSubmitter.submitted ? (
		<RocForm<ContactFormValues>
			onSubmit={contactFormSubmitter.handleSubmit}
			initialValues={initialValues}
			render={({ handleSubmit, submitError, submitting }) => {
				return (
					<form onSubmit={handleSubmit} className="roc-contact-form">
						<div className="roc-checkout__section">
							{submitError ? <InlineAlert message={submitError} error={null} /> : null}
							<TextBoxField name="name" label={Localizer('Name')} testId="contact-form-name-field" />
							<TextBoxField name="email" label={Localizer('Email')} />
							{/* #region HCL */}
							<TextBoxField name="customerNumber" label={Localizer('CustomerNumber')} />
							{/* #endregion HCL */}
							<TextAreaField name="message" label={Localizer('Message')} />
							<ReCaptchaDisclaimer isEnabled={ServerData.IsContactFormReCaptchaEnabled} />
							<button
								disabled={submitting}
								type="submit"
								className="roc-btn"
								data-testid="contact-form-submit"
							>
								{Localizer('Submit')} {submitting ? <Spinner light /> : null}
							</button>
						</div>
					</form>
				);
			}}
		/>
	) : (
		<p data-testid="contact-form-submitted">{Localizer('ContactFormSubmitted')}</p>
	);
}

export default ContactForm;
